// extracted by mini-css-extract-plugin
export default {"base":"base___bOPEN","siren":"siren___jWtRz"};